<template>
  <div class="consultIndex">
    <h2 class="sr-only">植樹專家諮詢平台</h2>
    <router-view></router-view>
  </div>
</template>
<script>
export default {
  name: "ConsultIndex"
};
</script>
<style lang="scss" scoped>
.consultIndex {
  height: 100%;
}
</style>
